<div class="container-fluid mt-3 px-4" style="font-size: 0.88rem;" *ngIf="!cargando">
  <form [formGroup]="editForm" (ngSubmit)="guardarCambios()">
    
    <!-- TITULO ADAPTADO AL ESTÁNDAR LIMPIO DE RECEPCIONES LIST -->
    <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
      <div>
        <h2 class="h5 m-0 fw-bold text-dark">Ajuste de Presupuesto - Folio: {{ folioCotizacion }}</h2>
        <span class="small text-muted font-monospace">JDE Commercial Adjuster / Estatus: {{ editForm.get('estatusAprobacion')?.value | uppercase }}</span>
      </div>
    </div>

    <div class="card border-0 bg-transparent">
      <div class="card-body p-0">
        
        <!-- Fila de Parámetros Comerciales -->
        <div class="row g-3 mb-4">
          <div class="col-md-3">
            <label class="form-label font-monospace fw-bold text-secondary">DIAS DE VIGENCIA</label>
            <input type="number" class="form-control form-control-sm shadow-sm" formControlName="vigenciaDias"
                   [ngClass]="{'is-invalid': (editForm.get('vigenciaDias')?.touched || intentarGuardar) && editForm.get('vigenciaDias')?.invalid}">
          </div>
          <div class="col-md-5">
            <label class="form-label font-monospace fw-bold text-secondary">COMENTARIOS / AJUSTES DEL TALLER</label>
            <input type="text" class="form-control form-control-sm shadow-sm text-uppercase" formControlName="comentariosCliente">
          </div>
          <div class="col-md-4 d-flex align-items-end justify-content-md-end">
            <div class="form-check form-switch p-2 bg-white rounded shadow-sm border border-secondary-subtle">
              <input class="form-check-input ms-0 me-2" type="checkbox" id="ivaEditSwitch" [(ngModel)]="ivaIncluido" [ngModelOptions]="{standalone: true}" (change)="conmutarIvaSwitch()">
              <label class="form-check-label fw-bold text-dark small" for="ivaEditSwitch">💰 Precios con IVA (16%)</label>
            </div>
          </div>
        </div>

        <!-- 🖼️ VISOR LOCAL DE EVIDENCIAS -->
        <div class="card mb-3 border-0 shadow-sm" *ngIf="data.fotos && data.fotos.length > 0">
          <div class="card-body p-3">
            <h6 class="fw-bold text-dark mb-3">📸 Evidencias de Patio (Inspección Local)</h6>
            
            <!-- Miniaturas -->
            <div class="d-flex gap-2 overflow-auto pb-2">
              <div *ngFor="let foto of data.fotos; let i = index" class="position-relative">
                <img [src]="foto.urlSanitizada" 
                    class="img-thumbnail custom-thumbnail"
                    (click)="mostrarVisorFotos = true; indiceFotoActual = i"
                    alt="Evidencia local" 
                    style="width: 110px; height: 80px; object-fit: cover; cursor: pointer;">
              </div>
            </div>
          </div>
        </div>

        <!-- 🌟 OVERLAY FLOTANTE MODERNO (Lightbox Carrusel Infinito JDE) -->
        <div class="lightbox-overlay-carousel" *ngIf="mostrarVisorFotos" (click)="cerrarVisor()">
          <div class="lightbox-content-frame" (click)="$event.stopPropagation()">
            
            <button type="button" class="btn-lightbox-close" (click)="cerrarVisor()">✕</button>
            
            <!-- Controles de navegación de carrusel infinito -->
            <button type="button" class="btn-lightbox-nav btn-lightbox-prev" (click)="fotoAnterior($event)">◀</button>
            
            <img [src]="data.fotos[indiceFotoActual].urlSanitizada" alt="Evidencia Ampliada" class="img-lightbox-large">
            
            <button type="button" class="btn-lightbox-nav btn-lightbox-next" (click)="fotoSiguiente($event)">▶</button>
            
          </div>
        </div>

        <!-- 🚗 CROQUIS VEHICULAR CON CONTENEDOR FÍSICO CORREGIDO PARA LOS PINES -->
        <div class="card shadow-sm border-secondary-subtle mb-4">
          <div class="card-header bg-dark text-white font-monospace fw-bold border-bottom">
            🚗 CROQUIS DE DAÑOS DE LA CARROCERÍA (MODALIDAD A)
          </div>
          <div class="card-body bg-white d-flex flex-column align-items-center py-4">
            <p class="text-muted small mb-3">💡 Seleccione un pin de daño sobre la silueta para transformarlo automáticamente en una partida presupuestal detallada.</p>
            
            <!-- 🌟 IMPORTANTE: El contenedor maestro debe tener exactamente la clase del CSS -->
            <div class="croquis-canvas-container" style="position: relative; display: inline-block;">
              <img [src]="currentVehicleSvg" alt="Silueta Dinámica" class="croquis-vehicle-img">
              
              <!-- 🎯 Pines reactivos tolerantes a ambas nomenclaturas (camelCase y snake_case) -->
              <div *ngFor="let pin of datosCarroceriaPatio" 
                   class="croquis-pin"
                   [style.left.%]="pin.x_percentage || pin.xPercentage"
                   [style.top.%]="pin.y_percentage || pin.yPercentage"
                   [ngClass]="{
                     'rayon': (pin.tipo_dano || pin.tipoDano) === 'RAYON',
                     'golpe': (pin.tipo_dano || pin.tipoDano) === 'GOLPE',
                     'rotura': (pin.tipo_dano || pin.tipoDano) === 'ROTURA',
                     'oxido': (pin.tipo_dano || pin.tipoDano) === 'OXIDO',
                     'picadura': (pin.tipo_dano || pin.tipoDano) === 'PICADURA'
                   }"
                   [title]="(pin.tipo_dano || pin.tipoDano) + ': ' + pin.descripcion"
                   (click)="vincularPinACotizacion(pin)">
              </div>
            </div>
          </div>
        </div>

        <!-- Tabla Multilínea de Partidas -->
        <div class="card shadow-sm mb-4" [ngClass]="intentarGuardar && lineas.length === 0 ? 'border-danger' : 'border-secondary-subtle'">
          <div class="card-header bg-light text-dark border-bottom d-flex justify-content-between align-items-center py-2.5">
            <span class="fw-bold font-monospace text-secondary">📋 PARTIDAS DE REPARACIÓN EDITABLES</span>
            <div>
              <button type="button" class="btn btn-sm btn-outline-success me-2 fw-bold shadow-sm" (click)="agregarNuevaLineaNueva('Refaccion')">➕ Refacción</button>
              <button type="button" class="btn btn-sm btn-outline-info text-dark me-2 fw-bold shadow-sm" (click)="agregarNuevaLineaNueva('Mano de Obra')">➕ Mano de Obra</button>
              <button type="button" class="btn btn-sm btn-outline-warning text-dark fw-bold shadow-sm" (click)="agregarNuevaLineaNueva('Servicio Externo')">➕ Ext. Especializado</button>
            </div>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-striped table-hover align-middle mb-0">
                <thead class="table-light text-center font-monospace small">
                  <tr>
                    <th style="width: 15%">Tipo</th>
                    <th style="width: 35%">Descripción Concepto</th>
                    <th style="width: 10%">Cant.</th>
                    <th style="width: 15%">P. Unitario</th>
                    <th style="width: 10%">Desc ($)</th>
                    <th style="width: 10%">Subtotal</th>
                    <th style="width: 5%">Acción</th>
                  </tr>
                </thead>
                <tbody formArrayName="lineas">
                  <!-- 🚀 INYECTADO: Si aprobadoPorCliente es false, se aplica un opacidad tenue y tachado al texto -->
                  <tr *ngFor="let control of lineas.controls; let i = index" [formGroupName]="i"
                      [ngStyle]="{
                        'opacity': control.get('aprobadoPorCliente')?.value ? '1' : '0.55',
                        'background-color': control.get('aprobadoPorCliente')?.value ? 'transparent' : '#f8d7da'
                      }">
                    <td>
                      <span class="badge w-100 py-2 ms-0 border text-center" 
                            [ngStyle]="{
                              'background-color': control.get('tipoItem')?.value === 'Mano de Obra' ? '#e7f1ff' : (control.get('tipoItem')?.value === 'Refaccion' ? '#198754' : '#ffc107'),
                              'color': control.get('tipoItem')?.value === 'Mano de Obra' ? '#0a58ca' : (control.get('tipoItem')?.value === 'Refaccion' ? '#ffffff' : '#664d03'),
                              'border-color': control.get('tipoItem')?.value === 'Mano de Obra' ? '#0d6efd' : 'transparent'
                            }" style="font-size: 0.78rem; font-weight: bold; border-radius: 4px;">
                        {{ control.get('tipoItem')?.value | uppercase }}
                      </span>
                    </td>
                    <td>
                      <!-- Texto con tachado condicional si fue rechazada por el cliente -->
                      <input type="text" class="form-control form-control-sm text-uppercase" formControlName="descripcion"
                             [style.text-decoration]="control.get('aprobadoPorCliente')?.value ? 'none' : 'line-through'"
                             [ngClass]="{'is-invalid': (control.get('descripcion')?.touched || intentarGuardar) && control.get('descripcion')?.invalid}">
                    </td>
                    <td>
                      <input type="number" class="form-control form-control-sm text-center font-monospace no-spinners" formControlName="cantidad" (wheel)="$event.preventDefault()"
                             [ngClass]="{'is-invalid': (control.get('cantidad')?.touched || intentarGuardar) && control.get('cantidad')?.invalid}">
                    </td>
                    <td>
                      <div class="input-group input-group-sm">
                        <span class="input-group-text font-monospace">$</span>
                        <!-- 🚨 ADICIÓN DE VALIDACIÓN ROJA EN CASO DE PRECIO INVÁLIDO -->
                        <input type="number" class="form-control text-end font-monospace no-spinners" formControlName="precioUnitario" (wheel)="$event.preventDefault()"
                               [ngClass]="{'is-invalid': (control.get('precioUnitario')?.touched || intentarGuardar) && control.get('precioUnitario')?.invalid}">
                      </div>
                    </td>
                    <td>
                      <input type="number" class="form-control form-control-sm text-end font-monospace no-spinners" formControlName="descuento" (wheel)="$event.preventDefault()">
                    </td>
                    <td class="text-end fw-bold px-3 font-monospace">
                      {{ control.get('subtotalLinea')?.value | currency:'MXN' }}
                    </td>
                    <td>
                      <button type="button" class="btn btn-sm btn-outline-danger border-0" (click)="removerLinea(i)">🗑️</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Cierre Financiero -->
        <div class="row justify-content-end bg-white p-3 rounded shadow-sm mx-0 border mb-4">
          <div class="col-md-4 font-monospace">
            <div class="d-flex justify-content-between py-2 border-bottom">
              <span class="text-muted fw-bold">SUBTOTAL NETO:</span>
              <span class="fw-bold text-dark">{{ editForm.get('subtotal')?.value | currency:'MXN' }}</span>
            </div>
            <div class="d-flex justify-content-between py-2 border-bottom">
              <span class="text-muted fw-bold">IVA TRASLADADO (16%):</span>
              <span class="fw-bold text-dark">{{ editForm.get('iva')?.value | currency:'MXN' }}</span>
            </div>
            <div class="d-flex justify-content-between py-2 pt-3 fs-5">
              <span class="text-dark fw-bold">TOTAL COMPROMISO:</span>
              <span class="text-dark fw-bold">{{ editForm.get('total')?.value | currency:'MXN' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer bg-light d-flex justify-content-end py-3 border-top px-0">
        <button type="button" class="btn btn-sm btn-outline-secondary px-4 me-3" (click)="alCancelar()" style="border-radius: 6px;">Cancelar</button>
        
        <!-- 🚀 BLOQUEO ABSOLUTO: disabled frena el click si no hay cambios y ngClass controla el color responsivo -->
        <button type="submit" 
                class="btn btn-sm px-5 fw-bold shadow-sm" 
                [disabled]="editForm.invalid || lineas.length === 0 || editForm.pristine"
                [ngClass]="editForm.invalid || lineas.length === 0 || editForm.pristine ? 'btn-primaryopacity text-primary' : 'btn-primary text-white'"
                style="border-radius: 6px; transition: all 0.2s ease-in-out;">
          💾 Actualizar Renglones y Recalcular
        </button>
      </div>

    </div>
  </form>
</div>